import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import {FormBuilder, FormGroup} from '@angular/forms';
import *  as $ from 'jquery';

///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_resultados35 } from 'app/idiomas/i18n/resultados35/resultados35.lang';

import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';

@Component({
  selector: 'app-menu-resultados',
  templateUrl: './menu-resultados.component.html',
  styleUrls: ['./menu-resultados.component.scss'],
  animations : fuseAnimations
})
export class MenuResultadosComponent implements OnInit {
  options: FormGroup;
  showAT:boolean = false;
  showFRP:boolean = false;
  showTableros:boolean = false;

  introduccion:boolean=true;
  generales:boolean=false;
  noRespondieron:boolean=false;
  atRespuestasEncuesta:boolean=false;
  sufrieronAcontecimiento:boolean=false;
  requierenAtencionClinica:boolean=false;
  frpRespuestasEncuesta:boolean=false;
  frpRespuestasIndividuales:boolean=false;
  tableroGlobal:boolean=false;
  tableroCategoria:boolean=false;
  tableroDominio:boolean=false;
  calificacionFinal:boolean=false;

  iconChangeAT:any="arrow_drop_down";
  iconChangeFRP:any="arrow_drop_down";
  iconChangeTableros:any="arrow_drop_down";

  colorIntroduccion:any="warn"
  colorGenerales:any;
  colorNorespondieron:any;

  colorAcontecimientos:any;
  colorRespuestas:any;
  colorPresenciaron:any;
  colorRequierenAtencion:any;

  colorFactores:any;
  colorRespuestasFactores:any;
  colorResultadosIndividuales:any;

  colorTableros:any;
  colorGlobal:any;
  colorCategoria:any;
  colorDominio:any;

  colorCalificacion:any;

  ventana_ancho = $(window).width();
  estatus:boolean=true;
  botonMenuEstatus:boolean=false;

  productoID:any
  nombreEmpresa:any;
  datos:any;
  centroDeTrabajoId:any

  constructor(
    fb: FormBuilder,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private wizardService: WizardService

  ) {
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_resultados35.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });


    this.options = fb.group({
      bottom: 0,
      fixed: false,
      top: 0
    });
    this.detectScreen();
  }

  ngOnInit() {
    this.detectScreen();
    if(localStorage.getItem("ctProductoId")){
      this.getDatosEmpresa();
      this.productoID=localStorage.getItem("ctProductoId");
      this.centroDeTrabajoId=localStorage.getItem("ctSeleccionadoId");
      console.log(this.productoID);
      console.log(this.centroDeTrabajoId);
    }
    else{
      this.getDatosEmpresaCentroTrabajo();
      this.productoID=localStorage.getItem('productoIdNorm35')
      this.centroDeTrabajoId=localStorage.getItem('id_CT');
      console.log(this.productoID);
      console.log(this.centroDeTrabajoId);
    }
  }

  onResize(event) {
  event.target.innerWidth;
  if(event.target.innerWidth<1080){
    this.estatus=false;
    this.botonMenuEstatus=true;
  }
  else{
    this.estatus=true;
    this.botonMenuEstatus=false;
  }
  }

  getDatosEmpresa(){
    this.wizardService.getDatosEmpresa().subscribe( (datos: backInter.infoEmpresa) => {
      // console.log(datos);
      this.nombreEmpresa=datos.data.nombreEmpresa;
    });
  }

  getDatosEmpresaCentroTrabajo(){
    this.wizardService.getDatosEmpresaCentroTrabajo(localStorage.getItem('empresaPadre')).subscribe( (datos: backInter.infoEmpresa) => {
      // console.log(datos);
      this.nombreEmpresa=datos.data.nombreEmpresa;
    });
  }

  configuracionMenu(pantalla:any) {
    switch (pantalla) {
      case 1:
      this.introduccion=true;
      this.generales=false;
      this.noRespondieron=false;
      this.atRespuestasEncuesta=false;
      this.sufrieronAcontecimiento=false;
      this.requierenAtencionClinica=false;
      this.frpRespuestasEncuesta=false;
      this.frpRespuestasIndividuales=false;
      this.tableroGlobal=false;
      this.tableroCategoria=false;
      this.tableroDominio=false;
      this.calificacionFinal=false;

      this.colorIntroduccion="warn";
      this.colorGenerales="";
      this.colorNorespondieron="";
      this.colorAcontecimientos="";
      this.colorRespuestas="";
      this.colorPresenciaron="";
      this.colorRequierenAtencion="";
      this.colorFactores="";
      this.colorRespuestasFactores="";
      this.colorResultadosIndividuales="";
      this.colorTableros="";
      this.colorGlobal="";
      this.colorCategoria="";
      this.colorDominio="";
      this.colorCalificacion="";
      break;

      case 2:
      this.introduccion=false;
      this.generales=true;
      this.noRespondieron=false;
      this.atRespuestasEncuesta=false;
      this.sufrieronAcontecimiento=false;
      this.requierenAtencionClinica=false;
      this.frpRespuestasEncuesta=false;
      this.frpRespuestasIndividuales=false;
      this.tableroGlobal=false;
      this.tableroCategoria=false;
      this.tableroDominio=false;
      this.calificacionFinal=false;

      this.colorIntroduccion="";
      this.colorGenerales="warn";
      this.colorNorespondieron="";
      this.colorAcontecimientos="";
      this.colorRespuestas="";
      this.colorPresenciaron="";
      this.colorRequierenAtencion="";
      this.colorFactores="";
      this.colorRespuestasFactores="";
      this.colorResultadosIndividuales="";
      this.colorTableros="";
      this.colorGlobal="";
      this.colorCategoria="";
      this.colorDominio="";
      this.colorCalificacion="";
      break;

      case 3:
      this.introduccion=false;
      this.generales=false;
      this.noRespondieron=true;
      this.atRespuestasEncuesta=false;
      this.sufrieronAcontecimiento=false;
      this.requierenAtencionClinica=false;
      this.frpRespuestasEncuesta=false;
      this.frpRespuestasIndividuales=false;
      this.tableroGlobal=false;
      this.tableroCategoria=false;
      this.tableroDominio=false;
      this.calificacionFinal=false;

      this.colorIntroduccion="";
      this.colorGenerales="";
      this.colorNorespondieron="warn";
      this.colorAcontecimientos="";
      this.colorRespuestas="";
      this.colorPresenciaron="";
      this.colorRequierenAtencion="";
      this.colorFactores="";
      this.colorRespuestasFactores="";
      this.colorResultadosIndividuales="";
      this.colorTableros="";
      this.colorGlobal="";
      this.colorCategoria="";
      this.colorDominio="";
      this.colorCalificacion="";
      break;

      case 4:
      this.colorIntroduccion="";
      this.colorGenerales="";
      this.colorNorespondieron="";
      this.colorAcontecimientos="warn";
      this.colorRespuestas="";
      this.colorPresenciaron="";
      this.colorRequierenAtencion="";
      this.colorFactores="";
      this.colorRespuestasFactores="";
      this.colorResultadosIndividuales="";
      this.colorTableros="";
      this.colorGlobal="";
      this.colorCategoria="";
      this.colorDominio="";
      this.colorCalificacion="";
      break;

      case 5:
      this.introduccion=false;
      this.generales=false;
      this.noRespondieron=false;
      this.atRespuestasEncuesta=true;
      this.sufrieronAcontecimiento=false;
      this.requierenAtencionClinica=false;
      this.frpRespuestasEncuesta=false;
      this.frpRespuestasIndividuales=false;
      this.tableroGlobal=false;
      this.tableroCategoria=false;
      this.tableroDominio=false;
      this.calificacionFinal=false;

      this.colorIntroduccion="";
      this.colorGenerales="";
      this.colorNorespondieron="";
      this.colorAcontecimientos="";
      this.colorRespuestas="warn";
      this.colorPresenciaron="";
      this.colorRequierenAtencion="";
      this.colorFactores="";
      this.colorRespuestasFactores="";
      this.colorResultadosIndividuales="";
      this.colorTableros="";
      this.colorGlobal="";
      this.colorCategoria="";
      this.colorDominio="";
      this.colorCalificacion="";
      break;

      case 6:
      this.introduccion=false;
      this.generales=false;
      this.noRespondieron=false;
      this.atRespuestasEncuesta=false;
      this.sufrieronAcontecimiento=true;
      this.requierenAtencionClinica=false;
      this.frpRespuestasEncuesta=false;
      this.frpRespuestasIndividuales=false;
      this.tableroGlobal=false;
      this.tableroCategoria=false;
      this.tableroDominio=false;
      this.calificacionFinal=false;

      this.colorIntroduccion="";
      this.colorGenerales="";
      this.colorNorespondieron="";
      this.colorAcontecimientos="";
      this.colorRespuestas="";
      this.colorPresenciaron="warn";
      this.colorRequierenAtencion="";
      this.colorFactores="";
      this.colorRespuestasFactores="";
      this.colorResultadosIndividuales="";
      this.colorTableros="";
      this.colorGlobal="";
      this.colorCategoria="";
      this.colorDominio="";
      this.colorCalificacion="";
      break;

      case 7:
      this.introduccion=false;
      this.generales=false;
      this.noRespondieron=false;
      this.atRespuestasEncuesta=false;
      this.sufrieronAcontecimiento=false;
      this.requierenAtencionClinica=true;
      this.frpRespuestasEncuesta=false;
      this.frpRespuestasIndividuales=false;
      this.tableroGlobal=false;
      this.tableroCategoria=false;
      this.tableroDominio=false;
      this.calificacionFinal=false;

      this.colorIntroduccion="";
      this.colorGenerales="";
      this.colorNorespondieron="";
      this.colorAcontecimientos="";
      this.colorRespuestas="";
      this.colorPresenciaron="";
      this.colorRequierenAtencion="warn";
      this.colorFactores="";
      this.colorRespuestasFactores="";
      this.colorResultadosIndividuales="";
      this.colorTableros="";
      this.colorGlobal="";
      this.colorCategoria="";
      this.colorDominio="";
      this.colorCalificacion="";
      break;

      case 8:
      this.colorIntroduccion="";
      this.colorGenerales="";
      this.colorNorespondieron="";
      this.colorAcontecimientos="";
      this.colorRespuestas="";
      this.colorPresenciaron="";
      this.colorRequierenAtencion="";
      this.colorFactores="warn";
      this.colorRespuestasFactores="";
      this.colorResultadosIndividuales="";
      this.colorTableros="";
      this.colorGlobal="";
      this.colorCategoria="";
      this.colorDominio="";
      this.colorCalificacion="";
      break;

      case 9:
      this.introduccion=false;
      this.generales=false;
      this.noRespondieron=false;
      this.atRespuestasEncuesta=false;
      this.sufrieronAcontecimiento=false;
      this.requierenAtencionClinica=false;
      this.frpRespuestasEncuesta=true;
      this.frpRespuestasIndividuales=false;
      this.tableroGlobal=false;
      this.tableroCategoria=false;
      this.tableroDominio=false;
      this.calificacionFinal=false;

      this.colorIntroduccion="";
      this.colorGenerales="";
      this.colorNorespondieron="";
      this.colorAcontecimientos="";
      this.colorRespuestas="";
      this.colorPresenciaron="";
      this.colorRequierenAtencion="";
      this.colorFactores="";
      this.colorRespuestasFactores="warn";
      this.colorResultadosIndividuales="";
      this.colorTableros="";
      this.colorGlobal="";
      this.colorCategoria="";
      this.colorDominio="";
      this.colorCalificacion="";
      break;

      case 10:
      this.introduccion=false;
      this.generales=false;
      this.noRespondieron=false;
      this.atRespuestasEncuesta=false;
      this.sufrieronAcontecimiento=false;
      this.requierenAtencionClinica=false;
      this.frpRespuestasEncuesta=false;
      this.frpRespuestasIndividuales=true;
      this.tableroGlobal=false;
      this.tableroCategoria=false;
      this.tableroDominio=false;
      this.calificacionFinal=false;

      this.colorIntroduccion="";
      this.colorGenerales="";
      this.colorNorespondieron="";
      this.colorAcontecimientos="";
      this.colorRespuestas="";
      this.colorPresenciaron="";
      this.colorRequierenAtencion="";
      this.colorFactores="";
      this.colorRespuestasFactores="";
      this.colorResultadosIndividuales="warn";
      this.colorTableros="";
      this.colorGlobal="";
      this.colorCategoria="";
      this.colorDominio="";
      this.colorCalificacion="";
      break;

      case 11:
      this.colorIntroduccion="";
      this.colorGenerales="";
      this.colorNorespondieron="";
      this.colorAcontecimientos="";
      this.colorRespuestas="";
      this.colorPresenciaron="";
      this.colorRequierenAtencion="";
      this.colorFactores="";
      this.colorRespuestasFactores="";
      this.colorResultadosIndividuales="";
      this.colorTableros="warn";
      this.colorGlobal="";
      this.colorCategoria="";
      this.colorDominio="";
      this.colorCalificacion="";
      break;

      case 12:
      this.introduccion=false;
      this.generales=false;
      this.noRespondieron=false;
      this.atRespuestasEncuesta=false;
      this.sufrieronAcontecimiento=false;
      this.requierenAtencionClinica=false;
      this.frpRespuestasEncuesta=false;
      this.frpRespuestasIndividuales=false;
      this.tableroGlobal=true;
      this.tableroCategoria=false;
      this.tableroDominio=false;
      this.calificacionFinal=false;

      this.colorIntroduccion="";
      this.colorGenerales="";
      this.colorNorespondieron="";
      this.colorAcontecimientos="";
      this.colorRespuestas="";
      this.colorPresenciaron="";
      this.colorRequierenAtencion="";
      this.colorFactores="";
      this.colorRespuestasFactores="";
      this.colorResultadosIndividuales="";
      this.colorTableros="";
      this.colorGlobal="warn";
      this.colorCategoria="";
      this.colorDominio="";
      this.colorCalificacion="";
      break;

      case 13:
      this.introduccion=false;
      this.generales=false;
      this.noRespondieron=false;
      this.atRespuestasEncuesta=false;
      this.sufrieronAcontecimiento=false;
      this.requierenAtencionClinica=false;
      this.frpRespuestasEncuesta=false;
      this.frpRespuestasIndividuales=false;
      this.tableroGlobal=false;
      this.tableroCategoria=true;
      this.tableroDominio=false;
      this.calificacionFinal=false;

      this.colorIntroduccion="";
      this.colorGenerales="";
      this.colorNorespondieron="";
      this.colorAcontecimientos="";
      this.colorRespuestas="";
      this.colorPresenciaron="";
      this.colorRequierenAtencion="";
      this.colorFactores="";
      this.colorRespuestasFactores="";
      this.colorResultadosIndividuales="";
      this.colorTableros="";
      this.colorGlobal="";
      this.colorCategoria="warn";
      this.colorDominio="";
      this.colorCalificacion="";
      break;

      case 14:
      this.introduccion=false;
      this.generales=false;
      this.noRespondieron=false;
      this.atRespuestasEncuesta=false;
      this.sufrieronAcontecimiento=false;
      this.requierenAtencionClinica=false;
      this.frpRespuestasEncuesta=false;
      this.frpRespuestasIndividuales=false;
      this.tableroGlobal=false;
      this.tableroCategoria=false;
      this.tableroDominio=true;
      this.calificacionFinal=false;

      this.colorIntroduccion="";
      this.colorGenerales="";
      this.colorNorespondieron="";
      this.colorAcontecimientos="";
      this.colorRespuestas="";
      this.colorPresenciaron="";
      this.colorRequierenAtencion="";
      this.colorFactores="";
      this.colorRespuestasFactores="";
      this.colorResultadosIndividuales="";
      this.colorTableros="";
      this.colorGlobal="";
      this.colorCategoria="";
      this.colorDominio="warn";
      this.colorCalificacion="";
      break;

      case 15:
      this.introduccion=false;
      this.generales=false;
      this.noRespondieron=false;
      this.atRespuestasEncuesta=false;
      this.sufrieronAcontecimiento=false;
      this.requierenAtencionClinica=false;
      this.frpRespuestasEncuesta=false;
      this.frpRespuestasIndividuales=false;
      this.tableroGlobal=false;
      this.tableroCategoria=false;
      this.tableroDominio=false;
      this.calificacionFinal=true;

      this.colorIntroduccion="";
      this.colorGenerales="";
      this.colorNorespondieron="";
      this.colorAcontecimientos="";
      this.colorRespuestas="";
      this.colorPresenciaron="";
      this.colorRequierenAtencion="";
      this.colorFactores="";
      this.colorRespuestasFactores="";
      this.colorResultadosIndividuales="";
      this.colorTableros="";
      this.colorGlobal="";
      this.colorCategoria="";
      this.colorDominio="";
      this.colorCalificacion="warn";
      break;

      default:
      break;
    }
  }

  menuAT() {
    this.showAT = !this.showAT;

    // CAMBIO DE ICONO
    if(this.showAT)
      this.iconChangeAT = "arrow_drop_up";
    else
      this.iconChangeAT = "arrow_drop_down";
  }

  menuFRP() {
    this.showFRP = !this.showFRP;

    // CAMBIO DE ICONO
    if(this.showFRP)
      this.iconChangeFRP = "arrow_drop_up";
    else
      this.iconChangeFRP = "arrow_drop_down";
  }

  menuTableros() {
    this.showTableros = !this.showTableros;

    // CAMBIO DE ICONO
    if(this.showTableros)
      this.iconChangeTableros = "arrow_drop_up";
    else
      this.iconChangeTableros = "arrow_drop_down";
  }

  detectScreen(){
      if(this.ventana_ancho<=1080){
        this.estatus=false;
        this.botonMenuEstatus=true;
      }
      else{
        this.estatus=true;
        this.botonMenuEstatus=false;
      }
    }

}
